import _ from 'lodash';
import { useStore } from '@/store';
import { isTreeItem, type TreeItem, type TreeNode } from '@morph-mapper/types';

export const useRuleConvert = () => {
  const [getEntries] = useStore(({ entries: e }) => [e.getEntries]);

  const getEntryPathSegments = (id: string): string[] => {
    const entries = getEntries();
    const segments: string[] = [];
    let currentId: string | undefined = id;

    while (currentId !== undefined) {
      const current: TreeNode | undefined = entries[currentId];
      if (!current || current.parentId === undefined) break;

      segments.unshift(current.key);
      currentId = current.parentId;
    }

    return segments;
  };

  const convertToRules = (template: any) => {
    if (!template) return { check: true, rules: [] };

    const entries = getEntries();

    const checksByKey: Record<string, any> = {};
    const updateObjectsByKey: Record<string, TreeItem['updateObject']> = {};
    const docRows: { key: string; name: string; path: string }[] = [];

    Object.values(entries)
      .filter(isTreeItem)
      .forEach((entry) => {
        const pathSegments = getEntryPathSegments(entry.id);

        if (pathSegments.includes('$declareVariable')) {
          const value = _.get(template, pathSegments);
          if (value !== undefined) {
            checksByKey[entry.key] = value;
          }
          if (entry.updateObject) {
            updateObjectsByKey[entry.key] = entry.updateObject;
          }
          return;
        }

        const docIndex = pathSegments.indexOf('doc');
        if (docIndex === -1) return;

        const value = _.get(template, pathSegments);
        if (value === undefined) return;

        docRows.push({
          key: entry.key,
          name: entry.name ?? entry.key,
          path: pathSegments.slice(docIndex).join('.'),
        });
      });

    const rules = docRows.map(({ key, name, path }) => ({
      name,
      path,
      ...updateObjectsByKey[key],
      enabled: updateObjectsByKey[key]?.enabled ?? false,
      check: checksByKey[key] ?? undefined,
    }));

    return { check: template.check, rules };
  };

  return {
    convertToRules,
  };
};
